import { Testimonial } from '@/types'

/**
 * Google İşletme Profili'ndeki gerçek müşteri yorumları.
 *
 * Metinler yorum sahiplerinin yazdığı haliyle, düzeltilmeden aktarılmıştır.
 * Tarihler Google'ın gösterdiği göreli biçimde saklanır (approxDate yalnızca
 * sıralama içindir) — gün/ay hassasiyetinde bir tarih uydurmamak için.
 *
 * ÖNEMLİ — yapılandırılmış veri:
 * Bu yorumlara Review/aggregateRating şeması EKLENMEZ. Google'ın politikası:
 * "If the entity that's being reviewed controls the reviews about itself,
 * their pages that use LocalBusiness or any other type of Organization
 * structured data are ineligible for star review feature."
 * Yani işletmenin kendi sitesine koyduğu kendi yorumları yıldız zengin
 * sonucu için uygun değildir; şema eklemek fayda sağlamaz, aksine
 * yapılandırılmış veri yaptırımı riski taşır. Yorumlar burada yalnızca
 * ziyaretçiye güven vermek için gösterilir; yıldızlar Google profilinde çıkar.
 */
export const testimonials: Testimonial[] = [
  {
    id: 'emir-dogus-saglam',
    name: 'Emir Doğuş Sağlam',
    rating: 5,
    relativeDate: '2 ay önce',
    approxDate: '2026-06',
    comment:
      '3 sene boyunca devletin dedektör görev köpeklerinin bakım ve tedavilerini üstlendi mustafa hocam. ' +
      'Genç yaşına rağmen bilgisi, tecrübesi, misafirperverliği ve köpeklerimize ilgisi şahaneydi. ' +
      'Maddiyatı ön plana koymadan tamamen çözüm ve sağlık odaklı tertemiz bir klinik burası. ' +
      'Düşünmeden tercih edebilirsiniz'
  },
  {
    id: 'miray-mustan',
    name: 'Miray Mustan',
    rating: 5,
    relativeDate: 'bir yıl önce',
    approxDate: '2025-08',
    comment:
      'gece 3 de doğum yapan kedimin sezaryenini yaptılar. çok ilgili davrandılar. ' +
      'her şey için çok teşekkürler. 4 tane yeni yavrumuz var'
  },
  {
    id: 'muhammed',
    name: 'Muhammed',
    rating: 5,
    relativeDate: '5 ay önce',
    approxDate: '2026-03',
    comment:
      'Kedim Gölge’yi rahatsızlığından dolayı ilk defa mustafa hocamıza götürdük. ' +
      'Kendi yavrularıymış gibi çok ilgilendiler. Müşteri gözüyle bakmayan bir klinik, ' +
      'artık gözümüz arkada değil. Ardıç vet ailesine teşekkür ederiz.'
  },
  {
    id: 'melis-demir',
    name: 'Melis Demir',
    rating: 5,
    relativeDate: '2 hafta önce',
    approxDate: '2026-08',
    comment:
      'Köpeğimi 1 haftalık emanet ettim. İlk defa ayrı kaldığım için açıkçası biraz endişeliydim ' +
      'ama gösterdikleri ilgi, özen ve profesyonellik sayesinde içim çok rahattı.'
  },
  {
    id: 'unal-kahraman',
    name: 'Ünal Kahraman',
    rating: 5,
    relativeDate: '4 ay önce',
    approxDate: '2026-04',
    comment:
      'Çok hijyenik, güler yüzlü ve ilgililer. Kedimi getirmiştim. Teknolojik altyapıları, ' +
      'kaliteli marka hizmetleriyle güvenimi kazandılar. Teşekkür ediyorum kendilerine. ' +
      'İşini layığıyla yapan iyi bir klinik.'
  },
  {
    id: 'cemil-demir',
    name: 'Cemil Demir',
    rating: 5,
    relativeDate: 'bir yıl önce',
    approxDate: '2025-08',
    comment:
      'Mustafa hocayı yıllardır tanırım kendisi çok iyi ve samimi, tecrübeli. ' +
      'Kedi köpeğinizi gönül rahatlığıyla götürebilirsiniz. Yeni yeriniz hayırlı uğurlu bereketli olsun.'
  },
  {
    id: 'eyyup-doni',
    name: 'Eyyup Doni',
    rating: 5,
    relativeDate: '8 ay önce',
    approxDate: '2025-12',
    comment:
      'Ardıç veteriner kliniği, iyi ki varsınız. Mustafa hocam ve ekip arkadaşlarınıza ne kadar ' +
      'teşekkür etsem azdır, ilgi ve alakanız için. Lunamız emin ellerde. ' +
      'Can yoldaşlarımız için mükemmel bir ekip ve ortam.'
  },
  {
    id: 'serkan-kaya',
    name: 'Serkan Kaya',
    rating: 5,
    relativeDate: '4 gün önce',
    approxDate: '2026-08',
    comment:
      'Bir tanıdığımızın yeri, gayet başarılı. Hijyenli ve profesyonel çalışıyorlar. Tavsiye ederim.'
  },
  {
    id: 'bilge-nur-yilmaz',
    name: 'Bilge Nur Yılmaz',
    rating: 5,
    relativeDate: '4 ay önce',
    approxDate: '2026-04',
    comment:
      'Teknolojik, tertemiz, güvenilir bir klinik. Kesinlikle tavsiye ediyorum. ' +
      'İşinin hakkını veren bir klinik, ilgilerine teşekkür ediyorum hekimimiz Mustafa Bey’e.'
  },
  {
    id: 'ibrahim-bayik',
    name: 'İbrahim Bayık',
    rating: 5,
    relativeDate: '6 ay önce',
    approxDate: '2026-02',
    comment:
      'Burası ilk açıldığında kedimi götürdüm, çok memnun kaldım. Hem teknik ekip hem ' +
      'Mustafa hocamızın tecrübeleri, ilgi ve alakasından dolayı çok teşekkür ederiz.'
  },
  {
    id: 'taha-findik',
    name: 'Taha Fındık',
    rating: 5,
    relativeDate: 'bir yıl önce',
    approxDate: '2025-08',
    comment:
      '3 pati babasıyım, hepsi Mustafa hocamın ellerinde büyüdü. ' +
      'İlgisinden şefkatinden çok memnunuz, herkese tavsiye ederim.'
  },
  {
    id: 'eren-a',
    name: 'Eren A.',
    rating: 5,
    relativeDate: '11 ay önce',
    approxDate: '2025-09',
    comment:
      'Her defasında hiç eksilmeyen ilgileri ve profesyonellikleri ile kedilerimi ' +
      'gözüm arkada kalmadan emanet ettiğim tek yer. İyi ki varsınız.'
  },
  {
    id: 'beyza-caliskan',
    name: 'Beyza Çalışkan',
    rating: 5,
    relativeDate: '9 ay önce',
    approxDate: '2025-11',
    comment:
      'Hekimlerinizin hem mesleki deneyimleri, bilgileri hem de güler yüzlerinden, anlayışından ' +
      'çok memnunuz. Çocuklarımızı emin ellere verdiğimizi her zaman hissediyoruz, her zaman tercihimiz.'
  },
  {
    id: 'emine-gul',
    name: 'Emine Gül',
    rating: 5,
    relativeDate: '5 ay önce',
    approxDate: '2026-03',
    comment:
      'Çok ilgili ve güler yüzlü bir ekip. Hayvanlara gerçekten sevgiyle yaklaşıyorlar ve ' +
      'bu hemen fark ediliyor. Böyle özenli bir klinik görmek çok güzel.'
  },
  {
    id: 'hayriye-hizar',
    name: 'Hayriye Hizar',
    rating: 5,
    relativeDate: 'bir yıl önce',
    approxDate: '2025-08',
    comment:
      'Samimiyetiniz ile doğallığınız çok güzeldi. Kızım yıllar sonra gerçek doktorunu buldu. ' +
      'İyi ki varsınız Ardıç Ailesi.'
  },
  {
    id: 'osman-kucuk',
    name: 'Osman Küçük',
    rating: 5,
    relativeDate: '9 ay önce',
    approxDate: '2025-11',
    comment:
      'Şimdiye kadar rastladığım en iyi veteriner kliniği. Gerçekten güler yüzlü ve ' +
      'profesyonel bir kadroya sahip, herkese tavsiye ediyorum gönül rahatlığıyla.'
  }
]

/** Yorumlar en yeniden eskiye sıralanır. */
export const testimonialsByDate = [...testimonials].sort((a, b) =>
  b.approxDate.localeCompare(a.approxDate)
)
